export default {
  affairManager: {
    type: {
      getFullTree: 'api/screen/affairType/getFullTree',
      getTypeTree: 'api/screen/affairType/getTypeTree',
      saveType: '/api/screen/affairType/saveType',
      updateType: '/api/screen/affairType/updateType',
      delType: '/api/screen/affairType/delType',
      dynamicTree: '/api/screen/affairType/dynamicTree'
    },
    matter: {
      saveMaterial:'/api/screen/affairMaterial/saveMaterial',
      updateMaterial: '/api/screen/affairMaterial/updateMaterial',
      delMaterial: '/api/screen/affairMaterial/delMaterial',
      getMaterialList: '/api/screen/affairMaterial/getMaterialList',
      getFile: "/api/screen/affairMaterial/getFile",
    },
  }
}
